/* eslint-disable no-undef */
/* eslint-disable react/prop-types */
import React, { useRef } from 'react';
import {
  Box,
  Chip,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@mui/material';
import { useIntl } from 'react-intl';
import { Download, ShareButton } from 'components/Download';

export default function TotalsPerTariff({
  valueInfo,
  generalReport,
  totalsPerHorary,
  totalsPerHoraryCost,
}) {
  const intl = useIntl();
  const tableRef = useRef();

  const data = [];
  let obj;

  if (generalReport != undefined || generalReport != null) {
    Object.values(generalReport).forEach((element) => {
      element.forEach((element2) => {
        obj = {
          hora: element2.Hora,
          medicion: element2.Kwh,
          color: element2.color,
        };
        data.push(obj);
      });
    });
  }

  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
  });

  return (
    <Paper sx={{ p: 2, overflowX: 'hidden', overflowY: 'auto' }} ref={tableRef}>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Chip
          label={
            valueInfo.kwh
              ? intl.formatMessage({
                  id: 'app.chargeSolar.board.totByPowerHours.title',
                })
              : intl.formatMessage({
                  id: 'app.chargeSolar.board.totByPowerHours.titleCost',
                })
          }
          sx={{
            fontWeight: 700,
            backgroundColor: '#730065',
            fontSize: '16px',
            color: 'white',
          }}
        />
        <Box display="flex" alignItems="center" gap={1}>
          <Download
            itemRef={tableRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.totByPowerHours.title',
            })}
          />
          <ShareButton
            itemRef={tableRef}
            name={intl.formatMessage({
              id: 'app.chargeSolar.board.totByPowerHours.title',
            })}
          />
        </Box>
      </Box>
      <Table size="medium" sx={{ width: '100%', minWidth: '100%' }}>
        <TableHead>
          <TableRow>
            <TableCell align="center">
              {' '}
              {intl.formatMessage({
                id: 'app.charge.board.totByPowerHours.base',
              })}{' '}
            </TableCell>
            <TableCell align="center">
              {' '}
              {intl.formatMessage({
                id: 'app.charge.board.totByPowerHours.intermediate',
              })}{' '}
            </TableCell>
            <TableCell align="center">
              {' '}
              {intl.formatMessage({
                id: 'app.charge.board.totByPowerHours.tip',
              })}{' '}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody style={{ padding: '0 !important' }}>
          {generalReport != undefined || generalReport != null ? (
            <TableRow style={{ height: '0px' }}>
              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{
                  backgroundColor: '#bfe5bf',
                  fontSize: '1em',
                  fontWeight: 'bold',
                }}
              >
                {valueInfo.money
                  ? formatter.format(Object.values(totalsPerHoraryCost)[0])
                  : Object.values(totalsPerHorary)[0]}{' '}
                kWh
              </TableCell>

              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{
                  backgroundColor: '#f2e5bf',
                  fontSize: '1em',
                  fontWeight: 'bold',
                }}
              >
                {valueInfo.money
                  ? formatter.format(Object.values(totalsPerHoraryCost)[1])
                  : Object.values(totalsPerHorary)[1]}{' '}
                kWh
              </TableCell>

              <TableCell
                component="th"
                scope="row"
                align="center"
                sx={{
                  backgroundColor: '#f2bfbf',
                  fontSize: '1em',
                  fontWeight: 'bold',
                }}
              >
                {valueInfo.money
                  ? formatter.format(Object.values(totalsPerHoraryCost)[2])
                  : Object.values(totalsPerHorary)[2]}{' '}
                kWh
              </TableCell>
            </TableRow>
          ) : null}
        </TableBody>
      </Table>
    </Paper>
  );
}
